export default [
  {
    text: 'На участке',
    value: 'location',
  },
  {
    text: 'По границе участка',
    value: 'border',
  },
  {
    text: 'Нет',
    value: 'no',
  },
];
